
export const state = {
    vModel: []
}

export const mutations = {
    SET_CURRENT_DATA(state, newValue) {
        let data ={}
        for( const key in newValue){
            console.log('store')
            console.log(`${key}:${newValue[key]}`)
            data[key]= newValue[key]
        }
        state.vModel.push(data)
        saveState('registration', newValue)
    }
}

export const getters = {
    // Whether the user is currently logged in.
    getInfo(state) {
        let notificationList=[]
        state.vModel.forEach(element => {
            console.log('element')
           notificationList.push([element?.notificatioTitle,element?.type,element?.date])
        });
        return notificationList
    }
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {
        //dispatch('validate')
    },
    updateInfo({commit},payload){
        commit('SET_CURRENT_DATA',payload)
    },
}

// ===
// Private helpers
// ===

function saveState(key, state) {
    window.sessionStorage.setItem(key, JSON.stringify(state))
}
